module.exports = __webpack_public_path__ + "img/virusColectivo8.f0f12895.jpg";